import { Component, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.less'],
  standalone: false
})
export class LogoComponent {
  @Output() logoClicked: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    this.logoClicked.emit();
  }
}
